import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "theme", "mini"],
    _excluded2 = ["theme"],
    _excluded3 = ["banner", "links", "user", "containerProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import Box from '../Box';
import Text from '../Text';
import Content from '../Content';
import BaseLink from '../Link';
import { useThemeDefaults } from '../utils';
import { User, MiniUser, UserMenu } from './User';
import { Links, Link } from './Links';
export var BannerText = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    as: "h1",
    textStyle: theme.topHeader.bannerTextStyle,
    whiteSpace: "nowrap"
  };
}, Text);
BannerText.propTypes = _objectSpread({}, Text.propTypes);
export var Banner = withTheme(function (_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      mini = _ref2.mini,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(BaseLink, _extends({
    role: "banner",
    color: theme.topHeader.color,
    mr: mini ? 0 : theme.topHeader.marginX,
    flex: "0 1 auto",
    display: "flex",
    alignItems: "center",
    hoverTextDecoration: "none"
  }, props), children);
});
Banner.propTypes = _objectSpread({}, BaseLink.propTypes);
export var Inner = useThemeDefaults(function () {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };
}, Content);
export var PlainOuter = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return {
    as: 'header',
    width: '100%',
    position: isMiniVariant(props) ? 'relative' : 'static',
    display: 'flex',
    alignItems: 'center',
    zIndex: 2,
    bg: theme.topHeader.bg,
    height: theme.topHeader.height
  };
}, styled(Box).withConfig({
  displayName: "TopHeader__PlainOuter",
  componentId: "sc-166t7q4-0"
})({
  overflowX: 'hidden'
}));

var isMiniVariant = function isMiniVariant(props) {
  return props.variant === 'mini';
};

var PlaceholderUser = /*#__PURE__*/React.createElement(Box, null);
export var Header = function Header(_ref4) {
  var banner = _ref4.banner,
      links = _ref4.links,
      _ref4$user = _ref4.user,
      user = _ref4$user === void 0 ? PlaceholderUser : _ref4$user,
      containerProps = _ref4.containerProps,
      props = _objectWithoutProperties(_ref4, _excluded3);

  return /*#__PURE__*/React.createElement(PlainOuter, _extends({
    variant: props.variant
  }, containerProps), /*#__PURE__*/React.createElement(Inner, props, banner && /*#__PURE__*/React.cloneElement(banner, _objectSpread({
    mini: isMiniVariant(props),
    order: isMiniVariant(props) ? 2 : 1
  }, banner.props)), links && /*#__PURE__*/React.cloneElement(links, _objectSpread({
    order: isMiniVariant(props) ? 1 : 2,
    mini: isMiniVariant(props)
  }, links.props)), user && /*#__PURE__*/React.cloneElement(user, _objectSpread({
    order: 3,
    mini: isMiniVariant(props)
  }, user.props))));
};
process.env.NODE_ENV !== "production" ? Header.propTypes = _objectSpread({
  variant: PropTypes.oneOf(['mini', 'full']),
  banner: PropTypes.element,
  links: PropTypes.element,
  user: PropTypes.element
}, Content.propTypes) : void 0;
Header.Banner = Banner;
Header.Links = Links;
Header.Link = Link;
Header.User = User;
Header.UserMenu = UserMenu;
Header.MiniUser = MiniUser;
Header.BannerText = BannerText;
export default Header;